import { render, staticRenderFns } from "./shopOrders.vue?vue&type=template&id=51f320b6&scoped=true"
import script from "./shopOrders.vue?vue&type=script&lang=js"
export * from "./shopOrders.vue?vue&type=script&lang=js"
import style0 from "./shopOrders.vue?vue&type=style&index=0&id=51f320b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f320b6",
  null
  
)

export default component.exports